import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const createQuestion = async (payload) => {
  const response = await fetch(`${API_URL}/api/questions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || "Failed to create question");
  }

  return await response.json();
};

export const fetchQuestions = async (page, pageSize) => {
  try {
    const res = await fetch(`${API_URL}/api/questions?page=${page}&limit=${pageSize}`);
    const response = await res.json();

    // ✅ Return full response object including pagination
    return {
      data: response.data,
      pagination: response.pagination,
    };
  } catch (error) {
    throw error;
  }
};
export const updateQuestion = async (id, payload) => {
  const response = await fetch(`${API_URL}/api/questions/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || "Failed to update question");
  }
  return await response.json();
};

export const fetchQuestionById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/api/questions/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const fetchLabels = async () => {
  const res = await fetch(`${API_URL}/api/labels`);
  if (!res.ok) throw new Error("Failed to fetch labels");
  const response = await res.json();
  return response.data || [];
};

// Find-or-create a label by name — returns {label, value}.
export const createLabel = async (name) => {
  const res = await fetch(`${API_URL}/api/labels`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || "Failed to create label");
  }
  const response = await res.json();
  return response.data;
};